/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { authorize, openDatabase } from "../services/api";
import Logo from "../assets/logo-old.png";

function Auth() {
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const params = new URLSearchParams(window.location.search);
  const [listDatabase, setListDatabase] = useState<any[]>([]);
  const [selectedDatabase, setSelectedDatabase] = useState<string>("");
  const [onSubmit, setOnSubmit] = useState(false);
  const codeParam = params.get("code") as string;
  const email = params.get("username") as string;

  useEffect(() => {
    async function fetchAPI() {
      try {
        if (codeParam) {
          const auth = await authorize(codeParam, email);
          if (
            codeParam &&
            auth &&
            auth.data.token &&
            auth.data.token.length > 0
          ) {
            setListDatabase(auth.data.token);
          } else {
            navigate("/login");
            toast.error("Code not Found", { position: "top-right" });
          }
        }
      } catch (err: any) {
        navigate("/login");
        toast.error(err.message || "Code not found", { position: "top-right" });
      } finally {
        setIsLoading(false);
      }
    }
    fetchAPI();
  }, [codeParam]);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setOnSubmit(true);

    if (selectedDatabase) {
      try {
        const response = await openDatabase(selectedDatabase, codeParam);
        if (response && response.data && response.data.success) {
          const token = response.data.token[0];
          const user = {
            name: token?.username,
          };
          localStorage.setItem("token", codeParam);
          localStorage.setItem("baseUrl", token.base_url);
          localStorage.setItem("business_id", token.business_id);

          localStorage.setItem("session", token.session_id);
          localStorage.setItem("accessToken", token.access_token);

          toast.success("Login successful", { position: "top-right" });
          navigate("/");
        } else {
          toast.error("Failed to open database", { position: "top-right" });
        }
      } catch (err: any) {
        toast.error(err.message || "Failed to open database", {
          position: "top-right",
        });
      } finally {
        setOnSubmit(false);
      }
    } else {
      toast.error("Please select a database", { position: "top-right" });
      setOnSubmit(false);
    }
  };
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-4">
      {isLoading ? (
        <div className="absolute inset-0 bg-white bg-opacity-75 flex flex-col items-center justify-center">
          <div className="loader border-t-4 border-b-4 border-blue-500 rounded-full w-12 h-12 animate-spin"></div>
          <p className="text-gray-700 text-lg font-medium mt-4">Loading...</p>
        </div>
      ) : null}
      <div className="flex flex-col items-center space-y-2">
        <img src={Logo} alt="Maxcode Logo" className="h-16" />

        <h1 className="text-xl font-bold text-center">
          Print Barcode integrated with Accurate
        </h1>
      </div>

      <div className="w-full max-w-md bg-white shadow-lg rounded-2xl p-6 mt-8">
        <h2 className="text-lg font-semibold text-center mb-4">
          Pilih "Login" untuk memulai
        </h2>
        <label
          htmlFor="database"
          className="block text-sm font-medium text-gray-700 mb-2"
        >
          Pilih Database
        </label>
        <select
          id="database"
          value={selectedDatabase}
          onChange={(e) => setSelectedDatabase(e.target.value)}
          className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        >
          <option value="">Pilih Database</option>
          {listDatabase.map((db) => (
            <option key={db.business_id} value={db.business_id}>
              {db.business_name}
            </option>
          ))}
        </select>
        <button
          onClick={handleSubmit}
          disabled={
            onSubmit || !selectedDatabase || selectedDatabase.length === 0
          }
          className="w-full bg-blue-500 text-white py-2 px-4 rounded-md mt-4 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
        >
          Submit
        </button>
        <button
          onClick={() => navigate("/login")}
          className="w-full bg-gray-300 text-gray-700 py-2 px-4 rounded-md mt-2 hover:bg-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-300 focus:ring-offset-2"
        >
          Back to Login
        </button>
      </div>

      <div className="mt-12 w-full max-w-md text-center">
        <h3 className="text-lg font-semibold">Contact Us:</h3>
        <p className="text-sm mt-2">
          <span className="font-medium">Telepon/WA #:</span> +62 818-8284-2888
        </p>
        <p className="text-sm">
          <span className="font-medium">Email:</span> admin@maksi.id
        </p>
        <p className="text-sm">
          <span className="font-medium">Website:</span>{" "}
          www.maksimediaindonesia.co.id
        </p>
      </div>

      <footer className="mt-12 text-center text-sm text-gray-500">
        Powered by PT. Maksi Media Indonesia © 2025
      </footer>
    </div>
  );
}

export default Auth;
